import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

const fetchItemByPkSk = async (PK: string, SK: string) => {
  const { data } = await axios.get(
    `${baseUrl}/aws/organizations_table/item/${encodeURIComponent(PK)}/${encodeURIComponent(SK)}`
  )
  return data
}

export const useGetItemByPkSk = (PK: string | undefined, SK: string | undefined, enabled = true) => {
  return useQuery({
    queryKey: ['item', PK, SK],
    queryFn: () => fetchItemByPkSk(PK!, SK!),
    enabled: enabled && !!PK && !!SK,
    staleTime: 30_000,
  })
}
